export default __webpack_public_path__ + "static/media/clubs.bf2c5a9a.svg";